module.exports = __webpack_public_path__ + "static/fonts/open-sans-v34-latin-500.35eca00e.woff2";